<template>
    <div>
        <h3>API</h3>
        <div>
            <p>
                貸し本棚には読み取り専用のAPIが用意されています。
                貸し本棚が用意するメールバックアップではなく、独自のバックアップアプリを作成する、
                あるいは独自のbotアプリで更新をツイートするなど、貸し本棚をベースとした開発の助けになります。
            </p>
            <p class="small text-danger">
                このマニュアルは開発者向け情報です。
            </p>

            <h4>APIトークンを取得する</h4>
            <p>
                マイページ
                ＞
                アカウント情報
                ＞
                <router-link to="/mypage/account/api">APIトークン</router-link>
                からAPIトークンを生成できます。
                トークン生成を実行すると、１度だけAPIトークンを表示します。
                このAPIトークンをリクエスト時にパラメータとして使用します。
            </p>

            <h4>ベースURL</h4>
            <div class="endpoint">
                https://api{{$store.state.base_domain}}
            </div>

            <h4>エンドポイント</h4>
            <p>
                APIによって取得できるのは、ご自身の作品情報のみです。
                他人の作品情報をリクエストした場合、認証エラーが返されます。
            </p>
            <p>
                APIのリクエストは <strong>1分で60回</strong> に制限されます。
                この閾値は予告なく変更されることがあります。
            </p>
            <p>
                APIトークンは、api_tokenパラメータとしてリクエストするか、Bearerトークンとして送信してください。
            </p>
            <pre class="sample">
<span class="comment"># パラメータ認証</span>
curl "https://api{{$store.state.base_domain}}/v1/novels?api_token=..."
<span class="comment"># Bearer認証</span>
curl -H 'authorization: Bearer ...' "https://api{{$store.state.base_domain}}/v1/novels"
</pre>

            <h5>小説一覧</h5>
            <p>
                ユーザーの登録小説情報を取得します。
            </p>
            <div class="endpoint">
                GET /v1/novels
            </div>
            <div class="params">
                パラメータ：
                なし
            </div>

            <h5>小説情報</h5>
            <p>
                指定の小説情報を取得します。
            </p>
            <div class="endpoint">
                GET /v1/novel/{id}
            </div>
            <div class="params">
                パラメータ：
                <dl>
                    <dt>id</dt>
                    <dd>小説id</dd>
                </dl>
                クエリパラメータ:
                <dl>
                    <dt>with_episodes</dt>
                    <dd>
                        1でエピソード一覧含む。
                        エピソードリストは章を含み、本文を含みません。
                    </dd>
                </dl>
            </div>

            <h5>エピソード一覧</h5>
            <p>
                指定小説のエピソード一覧を取得します。
                本文は含みません。
            </p>
            <div class="endpoint">
                GET /v1/episodes/{id}
            </div>
            <div class="params">
                パラメータ：
                <dl>
                    <dt>id</dt>
                    <dd>小説id</dd>
                </dl>
                クエリパラメータ：
                <dl>
                    <dt>is_published</dt>
                    <dd>
                        1で公開済みのみ。
                    </dd>
                </dl>
                <dl>
                    <dt>updated_after</dt>
                    <dd>
                        YYYY-MM-DD hh:mm:ss
                        指定日時以降に更新されたもののみ。
                    </dd>
                </dl>
            </div>

            <h5>エピソード情報</h5>
            <p>
                指定のエピソード情報を取得します。
            </p>
            <div class="endpoint">
                GET /v1/episode/{id}
            </div>
            <div class="params">
                パラメータ：
                <dl>
                    <dt>id</dt>
                    <dd>エピソードid</dd>
                </dl>
                クエリパラメータ：
                <dl>
                    <dt>with_book</dt>
                    <dd>
                        1で小説情報を含む。
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>
<style scoped lang="scss">
.endpoint {
    font-family: monospace;
    letter-spacing: 2px;
    margin: 1rem 0;
    padding: .5rem 1rem;
    background-color: #eee;
    color: #212529;
    border-radius: .5rem;
}
.sample {
    padding: 1rem;
    background-color: #eee;
    color: #212529;
    .comment {
        color: darkgreen;
    }
}
.params {
    margin-bottom: 2rem;
    dd {
        padding-left: 2rem;
    }
}
</style>

<script>
export default {
    created() {
        this.useHead({
            title: "API | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>